module.exports = __webpack_public_path__ + "static/media/OurMissionParagraph2.d290e234.JPG";